// acodeMap.js — 상품코드 ↔ 이카운트 A코드(품번) 매칭표와 상품명 사전.
//
// 출처: '상품코드 매칭표_2609.xlsx' (2026-09 기준, 원본 410행).
//   · ACODE_MAP     — A코드가 채워진 300건. 상품코드 → A코드
//   · PRODUCT_NAMES — 상품명이 있는 410건. 상품코드 → 상품명
//
// 적용 우선순위 (App.js):
//   1) ACODE_OVERRIDES  — 손으로 넣는 예외 보정. 항상 최우선
//   2) 현재고 엑셀 '상품메모' — ERP에서 매일 내려오는 실시간 값
//   3) ACODE_MAP (이 파일) — 위 두 개가 모두 비어 있을 때만 사용하는 보충 매칭표
//
// ACODE_MAP은 A코드 → 상품코드 역매칭(acodeIndex)의 씨앗으로도 쓴다.
// 현재고 엑셀에 없는 품목(재고 0인 신규품 등)이라도 발주 앱이 A코드로 보낸 물량을
// 올바른 상품코드에 붙이려면 이 표가 반드시 역인덱스에 들어가야 한다.
// (2026-09-01: 13054가 현재고 엑셀에 없어 A10184 발주가 별도 행으로 뜨던 문제를 이렇게 고쳤다.)
//
// PRODUCT_NAMES는 그렇게 만들어진 행의 이름이 비지 않도록 채워 주는 용도다.
//
// ⚠️ 이 표에 있다고 재고관리 목록에 '항상 표시'되지는 않는다. ALWAYS_SHOW_CODES는
//    ACODE_OVERRIDES(수동 등록분)만 대상으로 유지한다 — 매칭 전용 데이터이기 때문.
//
// 갱신: 새 매칭표 엑셀을 받으면 이 파일 하나만 통째로 교체하면 된다. App.js는 건드릴 필요 없다.

export const ACODE_MAP = {
  "12504": "A10008", // 이너홈 위생장갑 500매
  "12505": "A10009", // 이너홈 야채다지기 대용량(900ml)
  "12506": "A10010", // 이너홈 아이스 트레이 4구
  "12507": "A10011", // 이너홈 아이스 트레이 8구
  "12508": "A10012", // 이너홈 유청분리기 대용량
  "12509": "A10013", // 이너홈 빨아쓰는 체크패턴 행주 40매(25*30cm, 60gsm)
  "12510": "A10014", // 이너홈 일회용수세미 베이지 60매
  "12511": "A10015", // 이너홈 일회용수세미 그레이 60매
  "12512": "A10016", // 이너홈 비즈 가습기 INH-H220
  "12513": "A10017", // 이너홈 니트릴장갑 블랙 200매 소형
  "12514": "A10018", // 이너홈 니트릴장갑 블랙 200매 중형
  "12515": "A10019", // 이너홈 니트릴장갑 블랙 200매 대형
  "12516": "A10020", // 이너홈 니트릴장갑 화이트 200매 소형
  "12517": "A10021", // 이너홈 니트릴장갑 화이트 200매 중형
  "12518": "A10022", // 이너홈 니트릴장갑 화이트 200매 대형
  "12519": "A10023", // 이너홈 니트릴장갑 화이트 100매 중형
  "12520": "A10024", // 이너홈 니트릴장갑 화이트 100매 소형
  "12521": "A10025", // 이너홈 니트릴장갑 화이트 100매 대형
  "12522": "A10026", // 이너홈 니트릴장갑 블랙 100매 중형
  "12523": "A10027", // 이너홈 니트릴장갑 블랙 100매 소형
  "12524": "A10028", // 이너홈 니트릴장갑 블랙 100매 대형
  "12525": "A10029", // 지클럽 라텍스장갑 100매 대형
  "12526": "A10030", // 지클럽 라텍스장갑 100매 중형
  "12527": "A10031", // 지클럽 라텍스장갑 100매 소형
  "12528": "A10035", // 지클럽 니트릴장갑 200매 화이트 중형
  "12529": "A10036", // 지클럽 니트릴장갑 200매 화이트 소형
  "12530": "A10037", // 지클럽 니트릴장갑 200매 화이트 대형
  "12531": "A10038", // 지클럽 니트릴장갑 200매 블랙 소형
  "12532": "A10039", // 지클럽 니트릴장갑 200매 블랙 대형
  "12533": "A10040", // 지클럽 니트릴장갑 200매 블랙 중형
  "12534": "A10041", // 지클럽 니트릴장갑 100매 블루 소형
  "12535": "A10042", // 지클럽 팔목긴 니트릴장갑 블랙 100매(12인치) 중형
  "12536": "A10043", // 지클럽 팔목긴 니트릴장갑 블랙 100매(12인치) 대형
  "12537": "A10044", // 지클럽 팔목긴 니트릴장갑 블랙 100매(12인치) 소형
  "12538": "A10045", // 이너홈 더롱 30cm 니트릴 장갑 화이트 100매 소형
  "12539": "A10046", // 이너홈 더롱 30cm 니트릴 장갑 화이트 100매 중형
  "12540": "A10047", // 이너홈 더롱 30cm 니트릴 장갑 화이트 100매 대형
  "12541": "A10048", // 이너홈 더롱 30cm 니트릴 장갑 블랙 100매 소형
  "12542": "A10049", // 이너홈 더롱 30cm 니트릴 장갑 블랙 100매 중형
  "12543": "A10050", // 이너홈 더롱 30cm 니트릴 장갑 블랙 100매 대형
  "12544": "A10052", // 지클럽 니트릴장갑 100매 블루 중형
  "12545": "A10053", // 지클럽 니트릴장갑 100매 블루 대형
  "12546": "A10054", // 지클럽 니트릴 프리미엄 블루 100매 소형
  "12547": "A10055", // 지클럽 니트릴 프리미엄 블루 100매 중형
  "12548": "A10056", // 지클럽 니트릴 프리미엄 블루 100매 대형
  "12549": "A10057", // 지클럽 니트릴 프리미엄 블랙 100매 소형
  "12550": "A10058", // 지클럽 니트릴 프리미엄 블랙 100매 중형
  "12551": "A10059", // 지클럽 니트릴 프리미엄 블랙 100매 대형
  "12552": "A10063", // 유명테크 니트릴장갑 그레이 100매 (식품용) 대형
  "12553": "A10064", // 유명테크 니트릴장갑 그레이 100매 (식품용) 소형
  "12554": "A10065", // 유명테크 니트릴장갑 그레이 100매 (식품용) 중형
  "12555": "A10067", // 이너홈 손가락 PU 코팅장갑 10켤레 소형
  "12556": "A10068", // 이너홈 손가락 PU 코팅장갑 10켤레 중형
  "12557": "A10069", // 이너홈 손가락 PU 코팅장갑 10켤레 대형
  "12558": "A10070", // (국산)면장갑50g
  "12559": "A10071", // (수입)예식장갑(민자)_10켤레
  "12560": "A10072", // (국산)면장갑40g
  "12561": "A10073", // 이너홈 KF-AD 비말차단 마스크 흰색 대형 50매
  "12562": "A10074", // 이너홈 KF-AD 비말차단 마스크 흰색 대형 100매
  "12563": "A10075", // 이너홈 KF94 새부리형 마스크 블랙 대형 50매
  "12564": "A10076", // 이너홈 KF94 새부리형 마스크 블랙 대형 100매
  "12565": "A10077", // 이너홈 KF94 새부리형 마스크 흰색 대형 100매
  "12566": "A10078", // 이너홈 KF94 새부리형 마스크 흰색 대형 50매
  "12567": "A10079", // 이너홈 KF94 마스크 새부리형 흰색 대형 1매입
  "12568": "A10082", // 이너홈 KF94 새부리형 마스크 그레이 대형 50매
  "12569": "A10083", // 이너홈 KF94 새부리형 마스크 그레이 대형 100매
  "12570": "A10084", // 오랄비 유아 칫솔 스테이지스 4단계 스타워즈 4개
  "12571": "A10085", // 이너홈 비즈 가습기 INH-H220 블랙
  "12572": "A10087", // 이너홈 핸디형 스팀다리미 여행용 INH-3000
  "12573": "A10090", // 벡셀 AA(알카라인 20P)
  "12574": "A10091", // 벡셀 AAA(알카라인 20P)
  "12575": "A10096", // 파비스(베이직)
  "12576": "A10097", // 핑크워시
  "12577": "A10098", // 오랄비 유아 칫솔 스테이지 2단계 미키 4개
  "12578": "A10099", // 지클럽 니트릴장갑 블랙 소형(S) 100매
  "12579": "A10100", // 지클럽 니트릴장갑 블랙 중형(M) 100매
  "12580": "A10101", // 지클럽 니트릴장갑 블랙 대형(L) 100매
  "12581": "A10102", // 지클럽 니트릴장갑 블루 미니(XS) 100매
  "12582": "A10103", // 지클럽 니트릴장갑 화이트 미니(XS) 100매
  "12583": "A10104", // 지클럽 니트릴장갑 화이트 소형(S) 100매
  "12584": "A10105", // 지클럽 니트릴장갑 화이트 중형(M) 100매
  "12585": "A10106", // 지클럽 니트릴장갑 화이트 대형(L) 100매
  "12586": "A10107", // 바디스크럽 샤워장갑 그레이 2매
  "12587": "A10108", // CR2032 10알
  "12588": "A10109", // 벡셀 플래티넘 AA 20P
  "12589": "A10110", // 안티프라그S 칫솔 4입
  "12590": "A10111", // 템포 레귤러 20P
  "12591": "A10112", // 크린랩 가스렌지 미니
  "12592": "A10113", // 크린랩 하이퍼맥스 (AAA,AA)
  "12593": "A10114", // 면코팅 고무장갑 10매입
  "12594": "A10115", // 국산_적색반코팅장갑_100켤레
  "12595": "A10116", // 수입_적색반코팅장갑_100켤레
  "12596": "A10117", // 이너홈 튼튼 니트릴고무장갑 중형 화이트
  "12597": "A10118", // 이너홈 튼튼 니트릴고무장갑 대형 화이트
  "12598": "A10119", // 이너홈 튼튼 니트릴고무장갑 소형 화이트
  "12599": "A10120", // 이너홈 KF-AD 비말차단 마스크 블랙 대형 50매입 덴탈 마스크
  "12600": "A10125", // 집게고리
  "12601": "A10138", // 국산_황코팅 장갑 13G_50켤레
  "12602": "A10139", // 수입_백코팅 장갑 13G_50켤레
  "12603": "A10140", // 국산_PU 손끝 코팅장갑_흰색
  "12604": "A10141", // 국산_PU 손끝 코팅장갑_회색_10켤레
  "12605": "A10142", // 수입_면장갑 35G_10켤레
  "12609": "A10160", // NBR 코팅장갑 소형
  "12610": "A10161", // NBR 코팅장갑 중형
  "12611": "A10162", // NBR 코팅장갑 대형
  "12612": "A10163", // 디스펜서
  "12613": "A10164", // MAXUM 니트릴 블랙 100매 중형
  "12614": "A10165", // 팬틴 PRO-V 샴푸 린스 컨디셔너 1500ml 극손상 실키 스무드 엑스트라 볼륨 …
  "12615": "A10168", // 이너홈 튼튼 니트릴 고무장갑 소형 그린 면코팅
  "12616": "A10169", // 이너홈 튼튼 니트릴 고무장갑 중형 그린 면코팅
  "12617": "A10170", // 이너홈 튼튼 니트릴 고무장갑 대형 그린 면코팅
  "12618": "A10173", // 이너홈 식품용 위생랩 300mm x 500 meter
  "12619": "A10174", // 이너홈 식품용 위생랩 350mm x 500 meter
  "12620": "A10175", // 이너홈 식품용 위생랩 400mm x 500 meter
  "12621": "A10176", // (국산)면장갑 45g
  "12622": "A10177", // 망간 D형 건진지 24알
  "12623": "A10178", // 보비라이프 실속형 위생장갑 500매
  "12624": "A10179", // 크린랲 가스렌지 일반
  "12625": "A10180", // 지클럽 라텍스장갑 100매 미니(XS)
  "12626": "A10181", // 지클럽 라텍스장갑 100매 특대(XL)
  "12627": "A10186", // 벡셀 플래티넘 40P
  "12628": "A10187", // 아이 벡셀 AA2입 20알
  "12629": "A10188", // 아이 벡셀 AA2입 40알
  "12630": "A10189", // 면코팅 고무장갑 노랑 10 켤레
  "12631": "A10194", // 이너홈 KF94 새부리형 마스크 흰색 대형 1매입
  "12632": "A10195", // 이너홈 KF94 새부리형 마스크 블랙 대형 1매입
  "12633": "A10196", // 이너홈 KF94 새부리형 마스크 그레이 대형 1매입
  "12634": "A10197", // 이너홈 KF94 새부리형 마스크 그래이 대형 100매
  "12635": "A10207", // 국산_백코팅 장갑 13G_50켤레
  "12636": "A10208", // 수입_면장갑 50G_10켤레
  "12637": "A10210", // 크린랩 비장탄볼 (3kg) 캠핑 바베큐 구이용
  "12638": "A10211", // 리튬 건전지 CR2032 5알
  "12639": "A10212", // 오랄비 스테이지스 카즈 칫솔 12개
  "12640": "A10217", // 이너홈 튼튼 니트를 고무장갑 긴손목 380mm 소형 화이트
  "12641": "A10218", // 이너홈 튼튼 니트를 고무장갑 긴손목 380mm 중형 화이트
  "12642": "A10219", // 이너홈 튼튼 니트를 고무장갑 긴손목 380mm 대형 화이트
  "12643": "A10220", // 수입_면장갑 40G_10켤레
  "12644": "A10221", // 국산_면장갑 60G_10켤레
  "12645": "A10222", // 국산_PU도트코팅장갑_10켤레
  "12646": "A10223", // 박스테이프(삼우) 50개
  "12647": "A10224", // 센도리 AA 20알
  "12648": "A10225", // 센도리 AAA 20알
  "12649": "A10226", // 이너홈 튼튼 니트릴고무장갑 특대형 화이트
  "12650": "A10227", // 15데니아 밑트임(고리형,연커피)
  "12651": "A10228", // 15데니아 밑트임(고리형,스킨)
  "12652": "A10229", // 30D 착압 골프(고리형,연커피)
  "12653": "A10230", // 30D 착압 골프(고리형,스킨)
  "12654": "A10231", // 30D 착압 골프(9부,연커피) 발목형
  "12655": "A10232", // 30D 착압 골프(9부,스킨) 발목형
  "12656": "A10233", // 니하이스타킹(유발,검정색&스킨)
  "12657": "A10234", // 니하이스타킹(유발,백색&스킨)
  "12658": "A10235", // 니삭스스타킹(유발,검정색&스킨)
  "12659": "A10236", // 니삭스스타킹(유발,백색&스킨)
  "12660": "A10237", // 50데니아(9부,연커피)
  "12661": "A10238", // 50데니아(9브,스킨)
  "12662": "A10239", // 제이쏠코퍼레이션 버디버니 40D 골프 쿨 토시(커피색)-오른손장갑/왼쪽팔토시
  "12663": "A10240", // 제이쏠코퍼레이션 버디버니 40D 손목 쿨 토시(커피색)
  "12664": "A10241", // 제이쏠코퍼레이션 버디버니 40D 손목 쿨 토시(스킨색)
  "12665": "A10242", // 제이쏠코퍼레이션 버디버니 40D 골프 쿨 토시(스킨색)-오른손장갑/왼쪽팔토시
  "12666": "A10243", // 제이쏠코퍼레이션 버디버니 70D 골프 쿨 니삭스(블랙)
  "12667": "A10244", // 제이쏠코퍼레이션 버디버니 70D 골프 니 삭스(화이트)
  "12668": "A10245", // 증정용 다용도 타월(400x400mm)
  "12669": "A10246", // 조이엘로 가스렌지 G1
  "12670": "A10247", // 조이엘로 가스렌지 G2
  "12671": "A10248", // 조이엘로 가스렌지 G3
  "12672": "A10249", // 센도리 AA 40알
  "12673": "A10250", // 센도리 AA 100알
  "12674": "A10252", // 수입_황코팅 장갑 13G_50켤레
  "12675": "A10253", // 수입_이중 황코팅 장갑 13G_30켤레
  "12676": "A10254", // 수입_이중 청코팅 장갑 13G_30켤레
  "12677": "A10255", // 수입_완전 코팅장갑 13G_30켤레
  "12678": "A10257", // 국산_청코팅 장갑 13G_50켤레
  "12679": "A10258", // 국산_이중 황코팅 장갑 13G_30켤레
  "12680": "A10259", // 국산_이중 청코팅 장갑 13G_30켤레
  "12681": "A10264", // 수입_색사도트 장갑 48G_10켤레
  "12682": "A10265", // 베이직 가스렌지 ST-7000
  "12683": "A10266", // 완전연소 고화력 가스렌지 SW-슈퍼700
  "12684": "A10267", // 토네이도 가스렌지 빅마켓 ST-25000T
  "12685": "A10268", // 크린랩 가스렌지 스텐
  "12686": "A10269", // 수입_면장갑 45G_10켤레
  "12687": "A10270", // 수입_색사 장갑_35G_10켤레
  "12688": "A10271", // 크린랩 좋은참숯 (5-6인용) 2kg 캠핑 바베큐 구이용
  "12689": "A10272", // 센도리 AAA 40알
  "12690": "A10273", // 국산_면장갑 55g
  "12691": "A10274", // 국산_PU검정바닥코팅장갑_10켤레
  "12692": "A10275", // 몽키핸즈 SMART 터치장갑 M2 소형 10켤레
  "12693": "A10276", // 몽키핸즈 SMART 터치장갑 M2 중형 10켤레
  "12694": "A10277", // 몽키핸즈 SMART 터치장갑 M2 대형 10켤레
  "12695": "A10281", // 센도리 AA 1알
  "12696": "A10285", // 수입_면장갑 55G_10켤레
  "12697": "A10286", // 이너홈 주방용세제 구연산1Kg
  "12698": "A10287", // 이너홈 주방용세제 과탄산소다1Kg
  "12699": "A10288", // 이너홈 주방용세제 베이킹소다 6Kg
  "12700": "A10289", // 이너홈 주방용세제 구연산3Kg
  "12701": "A10290", // 이너홈 주방용세제 과탄산소다3Kg
  "12702": "A10291", // 이너홈 주방용세제 베이킹소다 2Kg
  "12703": "A10293", // 수입_PU 바닥 코팅장갑_10켤레
  "12704": "A10299", // 지클럽 니트릴장갑 블랙 미니(XS) 100매
  "12705": "A10300", // 스타일 가스렌지
  "12706": "A10313", // 이너홈 튼튼 니트릴 고무장갑 특대형 그린 면코팅
  "12707": "A10314", // 올케어 니트릴 고무장갑 4종세트 소형
  "12708": "A10315", // 올케어 니트릴 고무장갑 4종세트 중형
  "12709": "A10316", // 올케어 니트릴 고무장갑 4종세트 대형
  "12710": "A10327", // 몽키핸즈 SMART 터치장갑 M2 대형 1켤레
  "12711": "A10343", // 이너홈 니트릴장갑 화이트 100매 미니
  "12712": "A10344", // 이너홈 니트릴장갑 블랙 100매 미니
  "12713": "A10352", // 올케어 니트릴 고무장갑 6종세트
  "12714": "A10353", // 핫팩_80G
  "12715": "A10356", // 조이엘로 통주물 IH 프라이팬 30cm
  "12716": "A10375", // 수입_색사 장갑_35G_50켤레
  "12717": "A10376", // 몽키핸즈 M1(소형) 10켤레
  "12718": "A10377", // 몽키핸즈 M1(중형) 10켤레
  "12719": "A10378", // 몽키핸즈 M1(대형) 10켤레
  "12720": "A10379", // 몽키핸즈 M3(중형) 10켤레
  "12721": "A10381", // 몽키핸즈 M3(소형) 10켤레
  "12722": "A10386", // 국산_PU회색바닥코팅장갑_10켤레
  "12723": "A10387", // 몽키핸즈 M3(소형) 5켤레
  "12724": "A10388", // 몽키핸즈 M3(중형) 5켤레
  "12725": "A10389", // 몽키핸즈 M3(대형) 5켤레
  "12726": "A10390", // 몽키핸즈 M3(대형) 10켤레
  "12727": "A10391", // 이너홈 제스트 주방가위 SAVA2025(아이보리)
  "12728": "A10392", // 이너홈 과도
  "12729": "A10393", // 이너홈 셰프식도
  "12730": "A10394", // 이너홈 야채식도
  "12731": "A10401", // 썬터치 가스렌지 ST-SB4C(직사각 바람막이 대형)
  "12732": "A10407", // 이너홈 튼튼 니트릴 고무장갑 소형 그린 면코팅 10P
  "12733": "A10408", // 이너홈 튼튼 니트릴 고무장갑 중형 그린 면코팅 10P
  "12734": "A10409", // 이너홈 튼튼 니트릴 고무장갑 대형 그린 면코팅 10P
  "12735": "A10410", // 이너홈 튼튼 니트릴 고무장갑 특대형 그린 면코팅 10P
  "12736": "A10411", // 몽키핸즈 M3(대형) 1켤레
  "12737": "A10414", // 이너홈 알카라인 건전지 AA 20입
  "12738": "A10415", // 이너홈 알카라인 건전지 AAA 20입
  "12739": "A10416", // 이너홈 알카라인 건전지 AA 40입
  "12740": "A10417", // 이너홈 알카라인 건전지 AAA 40입
  "12741": "A10420", // 42g 표백 도트 목장갑 50개
  "12742": "A10421", // 몽키핸즈 M3(중형) 1켤레
  "12743": "A10422", // 이너홈 주방용세제 구연산5Kg
  "12744": "A10426", // 이너홈 니트릴장갑 화이트 300매 소형
  "12745": "A10427", // 이너홈 니트릴장갑 화이트 300매 중형
  "12746": "A10428", // 이너홈 니트릴장갑 화이트 300매 대형
  "12747": "A10430", // 이너홈 니트릴장갑 블랙 300매 소형
  "12748": "A10431", // 이너홈 니트릴장갑 블랙 300매 중형
  "12749": "A10432", // 이너홈 니트릴장갑 블랙 300매 대형
  "12750": "A10433", // 수입_면장갑 55G_50켤레
  "12751": "A10434", // 수입_목장갑 55g_50켤레
  "12752": "A10435", // 썬터치 가스렌지 TANK W
  "12753": "A10436", // 몽키핸즈 니트릴장갑 200매 화이트 소형
  "12754": "A10437", // 몽키핸즈 니트릴장갑 200매 화이트 중형
  "12755": "A10438", // 몽키핸즈 니트릴장갑 200매 화이트 대형
  "12756": "A10439", // 몽키핸즈 니트릴장갑 200매 블랙 소형
  "12757": "A10440", // 몽키핸즈 니트릴장갑 200매 블랙 중형
  "12758": "A10441", // 몽키핸즈 니트릴장갑 200매 블랙 대형
  "12759": "A10442", // 몽키핸즈 M1 소형 1켤레
  "12760": "A10443", // 몽키핸즈 M1 중형 1켤레
  "12761": "A10444", // 몽키핸즈 M1 대형 1켤레
  "12762": "A10445", // 이너홈 주방용세제 베이킹소다 12Kg
  "12763": "A10446", // 이너홈 주방용세제 베이킹소다 4Kg
  "12764": "A10449", // 이너홈 주방용세제 과탄산소다 5Kg
  "12765": "A10450", // 이너홈 더블 지퍼백 대형50매 4개
  "12766": "A10458", // RISCO ROLLBAG X-LARGE 40cmX50cm 400PCS
  "12767": "A10459", // RISCO ROLLBAG XX-LARGE 45cmX60cm 300PCS
  "12768": "A10460", // RISCO ROLLBAG XXX-LARGE 50cmX70cm 200PCS
  "12769": "A10461", // 3번들 이너홈 롤백 (17X25,25X35,30X40) 600PCS
  "12770": "A10462", // 4 BUNDLE RISCO ROLLBAG (17X25,25X35,30X40,35X4…
  "12771": "A10464", // 닥터바디 경추 베개
  "12901": "A10145", // 이너홈 더블 지퍼백 대형50매
  "12902": "A10144", // 이너홈 더블 지퍼백 중형50매
  "12903": "A10143", // 이너홈 더블 지퍼백 소형50매
  "12917": "A10473", // 이너홈 제스트 주방가위 SAVA2025 (그레이)
  "13054": "A10184", // 이너홈 튼튼 니트릴 고무장갑 그린 면코팅 3p 대형
  "13056": "A10182", // 이너홈 튼튼 니트릴 고무장갑 그린 면코팅 3p 소형
  "13058": "A10183", // 이너홈 튼튼 니트릴 고무장갑 그린 면코팅 3p 중형
  "13599": "A10547", // 이너홈 위생접시 14cm 15입
  "13600": "A10548", // 이너홈 위생접시 18cm 15입
  "13601": "A10549", // 이너홈 위생접시 23cm 15입
  "13631": "A10132", // 이너홈 튼튼 니트릴 고무장갑 소형 화이트 3P
  "13632": "A10133", // 이너홈 튼튼 니트릴 고무장갑 중형 화이트 3P
  "13633": "A10134", // 이너홈 튼튼 니트릴 고무장갑 대형 화이트 3P
  "13634": "A10135", // 이너홈 튼튼 니트릴 고무장갑 소형 화이트 5P
  "13635": "A10136", // 이너홈 튼튼 니트릴 고무장갑 중형 화이트 5P
  "13636": "A10137", // 이너홈 튼튼 니트릴 고무장갑 대형 화이트 5P
  "13637": "A10359", // 이너홈 튼튼 니트릴 고무장갑 특대형 그린 면코팅 3P
  "13638": "A10551", // 이너홈 니트릴장갑 100매 화이트 특대
  "13639": "A10552", // 이너홈 니트릴장갑 100매 블루 소형
  "13640": "A10553", // 이너홈 니트릴장갑 100매 블루 중형
  "13641": "A10554", // 이너홈 니트릴장갑 100매 블루 대형
  "13642": "A10555", // 이너홈 니트릴장갑 100매 블루 특대형
  "13643": "A10556", // 이너홈 니트릴장갑 100매 블랙 특대
  "13644": "A10557", // 클라우드 휩 안티 헤어 로스 샴푸 740ml X 2개
  "13645": "A10558", // 케라틴 헤어 오일 세럼 45ml x 2개
  "13646": "A10559", // 오라리쉬 헤어 프리즈 컨트롤 시스템 3단계 케어 3종세트 세럼, 샴푸, 헤어팩, 각…
  "13647": "A10560", // 이너홈 니트릴장갑 200매 화이트 초소형
  "13648": "A10561", // 고무장갑 특대형 2개 + 튼튼고무장갑 면코팅 특대형 2개
  "13649": "A10562", // 발각질제거기(바이올렛)1개+샤워장갑2입
  "13650": "A10563", // 이너홈 튼튼 니트릴 고무장갑 소형 바이올렛
  "13651": "A10564", // 이너홈 튼튼 니트릴 고무장갑 중형 바이올렛
  "13652": "A10565", // 이너홈 튼튼 니트릴 고무장갑 대형 바이올렛
  "13653": "A10566", // 이너홈 튼튼 니트릴 고무장갑 소형 바이올렛 3P
  "13654": "A10567", // 이너홈 튼튼 니트릴 고무장갑 중형 바이올렛 3P
  "13655": "A10568", // 이너홈 튼튼 니트릴 고무장갑 대형 바이올렛 3P
};

// 현재고 엑셀에 없는 품목이 발주 물량 때문에 목록에 생길 때 이름이 비지 않도록 보완한다.
// 엑셀에 이름이 있으면 언제나 엑셀 값이 우선한다.
export const PRODUCT_NAMES = {
  "12431": "조이엘로 통주물 IH 프라이팬 24cm",
  "12432": "조이엘로 통주물 IH 프라이팬 28cm",
  "12434": "조이엘로 통주물 IH 궁중팬 24cm",
  "12435": "조이엘로 통주물 IH 궁중팬 28cm",
  "12442": "조이엘로 통주불 IH 올리브(그린) 궁중팬 28cm",
  "12443": "조이엘로 통주불 IH 올리브(그린) 프라이팬 28cm",
  "12504": "이너홈 위생장갑 500매",
  "12505": "이너홈 야채다지기 대용량(900ml)",
  "12506": "이너홈 아이스 트레이 4구",
  "12507": "이너홈 아이스 트레이 8구",
  "12508": "이너홈 유청분리기 대용량",
  "12509": "이너홈 빨아쓰는 체크패턴 행주 40매(25*30cm, 60gsm)",
  "12510": "이너홈 일회용수세미 베이지 60매",
  "12511": "이너홈 일회용수세미 그레이 60매",
  "12512": "이너홈 비즈 가습기 INH-H220",
  "12513": "이너홈 니트릴장갑 블랙 200매 소형",
  "12514": "이너홈 니트릴장갑 블랙 200매 중형",
  "12515": "이너홈 니트릴장갑 블랙 200매 대형",
  "12516": "이너홈 니트릴장갑 화이트 200매 소형",
  "12517": "이너홈 니트릴장갑 화이트 200매 중형",
  "12518": "이너홈 니트릴장갑 화이트 200매 대형",
  "12519": "이너홈 니트릴장갑 화이트 100매 중형",
  "12520": "이너홈 니트릴장갑 화이트 100매 소형",
  "12521": "이너홈 니트릴장갑 화이트 100매 대형",
  "12522": "이너홈 니트릴장갑 블랙 100매 중형",
  "12523": "이너홈 니트릴장갑 블랙 100매 소형",
  "12524": "이너홈 니트릴장갑 블랙 100매 대형",
  "12525": "지클럽 라텍스장갑 100매 대형",
  "12526": "지클럽 라텍스장갑 100매 중형",
  "12527": "지클럽 라텍스장갑 100매 소형",
  "12528": "지클럽 니트릴장갑 200매 화이트 중형",
  "12529": "지클럽 니트릴장갑 200매 화이트 소형",
  "12530": "지클럽 니트릴장갑 200매 화이트 대형",
  "12531": "지클럽 니트릴장갑 200매 블랙 소형",
  "12532": "지클럽 니트릴장갑 200매 블랙 대형",
  "12533": "지클럽 니트릴장갑 200매 블랙 중형",
  "12534": "지클럽 니트릴장갑 100매 블루 소형",
  "12535": "지클럽 팔목긴 니트릴장갑 블랙 100매(12인치) 중형",
  "12536": "지클럽 팔목긴 니트릴장갑 블랙 100매(12인치) 대형",
  "12537": "지클럽 팔목긴 니트릴장갑 블랙 100매(12인치) 소형",
  "12538": "이너홈 더롱 30cm 니트릴 장갑 화이트 100매 소형",
  "12539": "이너홈 더롱 30cm 니트릴 장갑 화이트 100매 중형",
  "12540": "이너홈 더롱 30cm 니트릴 장갑 화이트 100매 대형",
  "12541": "이너홈 더롱 30cm 니트릴 장갑 블랙 100매 소형",
  "12542": "이너홈 더롱 30cm 니트릴 장갑 블랙 100매 중형",
  "12543": "이너홈 더롱 30cm 니트릴 장갑 블랙 100매 대형",
  "12544": "지클럽 니트릴장갑 100매 블루 중형",
  "12545": "지클럽 니트릴장갑 100매 블루 대형",
  "12546": "지클럽 니트릴 프리미엄 블루 100매 소형",
  "12547": "지클럽 니트릴 프리미엄 블루 100매 중형",
  "12548": "지클럽 니트릴 프리미엄 블루 100매 대형",
  "12549": "지클럽 니트릴 프리미엄 블랙 100매 소형",
  "12550": "지클럽 니트릴 프리미엄 블랙 100매 중형",
  "12551": "지클럽 니트릴 프리미엄 블랙 100매 대형",
  "12552": "유명테크 니트릴장갑 그레이 100매 (식품용) 대형",
  "12553": "유명테크 니트릴장갑 그레이 100매 (식품용) 소형",
  "12554": "유명테크 니트릴장갑 그레이 100매 (식품용) 중형",
  "12555": "이너홈 손가락 PU 코팅장갑 10켤레 소형",
  "12556": "이너홈 손가락 PU 코팅장갑 10켤레 중형",
  "12557": "이너홈 손가락 PU 코팅장갑 10켤레 대형",
  "12558": "(국산)면장갑50g",
  "12559": "(수입)예식장갑(민자)_10켤레",
  "12560": "(국산)면장갑40g",
  "12561": "이너홈 KF-AD 비말차단 마스크 흰색 대형 50매",
  "12562": "이너홈 KF-AD 비말차단 마스크 흰색 대형 100매",
  "12563": "이너홈 KF94 새부리형 마스크 블랙 대형 50매",
  "12564": "이너홈 KF94 새부리형 마스크 블랙 대형 100매",
  "12565": "이너홈 KF94 새부리형 마스크 흰색 대형 100매",
  "12566": "이너홈 KF94 새부리형 마스크 흰색 대형 50매",
  "12567": "이너홈 KF94 마스크 새부리형 흰색 대형 1매입",
  "12568": "이너홈 KF94 새부리형 마스크 그레이 대형 50매",
  "12569": "이너홈 KF94 새부리형 마스크 그레이 대형 100매",
  "12570": "오랄비 유아 칫솔 스테이지스 4단계 스타워즈 4개",
  "12571": "이너홈 비즈 가습기 INH-H220 블랙",
  "12572": "이너홈 핸디형 스팀다리미 여행용 INH-3000",
  "12573": "벡셀 AA(알카라인 20P)",
  "12574": "벡셀 AAA(알카라인 20P)",
  "12575": "파비스(베이직)",
  "12576": "핑크워시",
  "12577": "오랄비 유아 칫솔 스테이지 2단계 미키 4개",
  "12578": "지클럽 니트릴장갑 블랙 소형(S) 100매",
  "12579": "지클럽 니트릴장갑 블랙 중형(M) 100매",
  "12580": "지클럽 니트릴장갑 블랙 대형(L) 100매",
  "12581": "지클럽 니트릴장갑 블루 미니(XS) 100매",
  "12582": "지클럽 니트릴장갑 화이트 미니(XS) 100매",
  "12583": "지클럽 니트릴장갑 화이트 소형(S) 100매",
  "12584": "지클럽 니트릴장갑 화이트 중형(M) 100매",
  "12585": "지클럽 니트릴장갑 화이트 대형(L) 100매",
  "12586": "바디스크럽 샤워장갑 그레이 2매",
  "12587": "CR2032 10알",
  "12588": "벡셀 플래티넘 AA 20P",
  "12589": "안티프라그S 칫솔 4입",
  "12590": "템포 레귤러 20P",
  "12591": "크린랩 가스렌지 미니",
  "12592": "크린랩 하이퍼맥스 (AAA,AA)",
  "12593": "면코팅 고무장갑 10매입",
  "12594": "국산_적색반코팅장갑_100켤레",
  "12595": "수입_적색반코팅장갑_100켤레",
  "12596": "이너홈 튼튼 니트릴고무장갑 중형 화이트",
  "12597": "이너홈 튼튼 니트릴고무장갑 대형 화이트",
  "12598": "이너홈 튼튼 니트릴고무장갑 소형 화이트",
  "12599": "이너홈 KF-AD 비말차단 마스크 블랙 대형 50매입 덴탈 마스크",
  "12600": "집게고리",
  "12601": "국산_황코팅 장갑 13G_50켤레",
  "12602": "수입_백코팅 장갑 13G_50켤레",
  "12603": "국산_PU 손끝 코팅장갑_흰색",
  "12604": "국산_PU 손끝 코팅장갑_회색_10켤레",
  "12605": "수입_면장갑 35G_10켤레",
  "12606": "DB ZIPPER BAG 18X20 50매_Small",
  "12607": "DB ZIPPER BAG 22X25 50매_Medium",
  "12608": "DB ZIPPER BAG 25x30 50매_Large",
  "12609": "NBR 코팅장갑 소형",
  "12610": "NBR 코팅장갑 중형",
  "12611": "NBR 코팅장갑 대형",
  "12612": "디스펜서",
  "12613": "MAXUM 니트릴 블랙 100매 중형",
  "12614": "팬틴 PRO-V 샴푸 린스 컨디셔너 1500ml 극손상 실키 스무드 엑스트라 볼륨 손상모",
  "12615": "이너홈 튼튼 니트릴 고무장갑 소형 그린 면코팅",
  "12616": "이너홈 튼튼 니트릴 고무장갑 중형 그린 면코팅",
  "12617": "이너홈 튼튼 니트릴 고무장갑 대형 그린 면코팅",
  "12618": "이너홈 식품용 위생랩 300mm x 500 meter",
  "12619": "이너홈 식품용 위생랩 350mm x 500 meter",
  "12620": "이너홈 식품용 위생랩 400mm x 500 meter",
  "12621": "(국산)면장갑 45g",
  "12622": "망간 D형 건진지 24알",
  "12623": "보비라이프 실속형 위생장갑 500매",
  "12624": "크린랲 가스렌지 일반",
  "12625": "지클럽 라텍스장갑 100매 미니(XS)",
  "12626": "지클럽 라텍스장갑 100매 특대(XL)",
  "12627": "벡셀 플래티넘 40P",
  "12628": "아이 벡셀 AA2입 20알",
  "12629": "아이 벡셀 AA2입 40알",
  "12630": "면코팅 고무장갑 노랑 10 켤레",
  "12631": "이너홈 KF94 새부리형 마스크 흰색 대형 1매입",
  "12632": "이너홈 KF94 새부리형 마스크 블랙 대형 1매입",
  "12633": "이너홈 KF94 새부리형 마스크 그레이 대형 1매입",
  "12634": "이너홈 KF94 새부리형 마스크 그래이 대형 100매",
  "12635": "국산_백코팅 장갑 13G_50켤레",
  "12636": "수입_면장갑 50G_10켤레",
  "12637": "크린랩 비장탄볼 (3kg) 캠핑 바베큐 구이용",
  "12638": "리튬 건전지 CR2032 5알",
  "12639": "오랄비 스테이지스 카즈 칫솔 12개",
  "12640": "이너홈 튼튼 니트를 고무장갑 긴손목 380mm 소형 화이트",
  "12641": "이너홈 튼튼 니트를 고무장갑 긴손목 380mm 중형 화이트",
  "12642": "이너홈 튼튼 니트를 고무장갑 긴손목 380mm 대형 화이트",
  "12643": "수입_면장갑 40G_10켤레",
  "12644": "국산_면장갑 60G_10켤레",
  "12645": "국산_PU도트코팅장갑_10켤레",
  "12646": "박스테이프(삼우) 50개",
  "12647": "센도리 AA 20알",
  "12648": "센도리 AAA 20알",
  "12649": "이너홈 튼튼 니트릴고무장갑 특대형 화이트",
  "12650": "15데니아 밑트임(고리형,연커피)",
  "12651": "15데니아 밑트임(고리형,스킨)",
  "12652": "30D 착압 골프(고리형,연커피)",
  "12653": "30D 착압 골프(고리형,스킨)",
  "12654": "30D 착압 골프(9부,연커피) 발목형",
  "12655": "30D 착압 골프(9부,스킨) 발목형",
  "12656": "니하이스타킹(유발,검정색&스킨)",
  "12657": "니하이스타킹(유발,백색&스킨)",
  "12658": "니삭스스타킹(유발,검정색&스킨)",
  "12659": "니삭스스타킹(유발,백색&스킨)",
  "12660": "50데니아(9부,연커피)",
  "12661": "50데니아(9브,스킨)",
  "12662": "제이쏠코퍼레이션 버디버니 40D 골프 쿨 토시(커피색)-오른손장갑/왼쪽팔토시",
  "12663": "제이쏠코퍼레이션 버디버니 40D 손목 쿨 토시(커피색)",
  "12664": "제이쏠코퍼레이션 버디버니 40D 손목 쿨 토시(스킨색)",
  "12665": "제이쏠코퍼레이션 버디버니 40D 골프 쿨 토시(스킨색)-오른손장갑/왼쪽팔토시",
  "12666": "제이쏠코퍼레이션 버디버니 70D 골프 쿨 니삭스(블랙)",
  "12667": "제이쏠코퍼레이션 버디버니 70D 골프 니 삭스(화이트)",
  "12668": "증정용 다용도 타월(400x400mm)",
  "12669": "조이엘로 가스렌지 G1",
  "12670": "조이엘로 가스렌지 G2",
  "12671": "조이엘로 가스렌지 G3",
  "12672": "센도리 AA 40알",
  "12673": "센도리 AA 100알",
  "12674": "수입_황코팅 장갑 13G_50켤레",
  "12675": "수입_이중 황코팅 장갑 13G_30켤레",
  "12676": "수입_이중 청코팅 장갑 13G_30켤레",
  "12677": "수입_완전 코팅장갑 13G_30켤레",
  "12678": "국산_청코팅 장갑 13G_50켤레",
  "12679": "국산_이중 황코팅 장갑 13G_30켤레",
  "12680": "국산_이중 청코팅 장갑 13G_30켤레",
  "12681": "수입_색사도트 장갑 48G_10켤레",
  "12682": "베이직 가스렌지 ST-7000",
  "12683": "완전연소 고화력 가스렌지 SW-슈퍼700",
  "12684": "토네이도 가스렌지 빅마켓 ST-25000T",
  "12685": "크린랩 가스렌지 스텐",
  "12686": "수입_면장갑 45G_10켤레",
  "12687": "수입_색사 장갑_35G_10켤레",
  "12688": "크린랩 좋은참숯 (5-6인용) 2kg 캠핑 바베큐 구이용",
  "12689": "센도리 AAA 40알",
  "12690": "국산_면장갑 55g",
  "12691": "국산_PU검정바닥코팅장갑_10켤레",
  "12692": "몽키핸즈 SMART 터치장갑 M2 소형 10켤레",
  "12693": "몽키핸즈 SMART 터치장갑 M2 중형 10켤레",
  "12694": "몽키핸즈 SMART 터치장갑 M2 대형 10켤레",
  "12695": "센도리 AA 1알",
  "12696": "수입_면장갑 55G_10켤레",
  "12697": "이너홈 주방용세제 구연산1Kg",
  "12698": "이너홈 주방용세제 과탄산소다1Kg",
  "12699": "이너홈 주방용세제 베이킹소다 6Kg",
  "12700": "이너홈 주방용세제 구연산3Kg",
  "12701": "이너홈 주방용세제 과탄산소다3Kg",
  "12702": "이너홈 주방용세제 베이킹소다 2Kg",
  "12703": "수입_PU 바닥 코팅장갑_10켤레",
  "12704": "지클럽 니트릴장갑 블랙 미니(XS) 100매",
  "12705": "스타일 가스렌지",
  "12706": "이너홈 튼튼 니트릴 고무장갑 특대형 그린 면코팅",
  "12707": "올케어 니트릴 고무장갑 4종세트 소형",
  "12708": "올케어 니트릴 고무장갑 4종세트 중형",
  "12709": "올케어 니트릴 고무장갑 4종세트 대형",
  "12710": "몽키핸즈 SMART 터치장갑 M2 대형 1켤레",
  "12711": "이너홈 니트릴장갑 화이트 100매 미니",
  "12712": "이너홈 니트릴장갑 블랙 100매 미니",
  "12713": "올케어 니트릴 고무장갑 6종세트",
  "12714": "핫팩_80G",
  "12715": "조이엘로 통주물 IH 프라이팬 30cm",
  "12716": "수입_색사 장갑_35G_50켤레",
  "12717": "몽키핸즈 M1(소형) 10켤레",
  "12718": "몽키핸즈 M1(중형) 10켤레",
  "12719": "몽키핸즈 M1(대형) 10켤레",
  "12720": "몽키핸즈 M3(중형) 10켤레",
  "12721": "몽키핸즈 M3(소형) 10켤레",
  "12722": "국산_PU회색바닥코팅장갑_10켤레",
  "12723": "몽키핸즈 M3(소형) 5켤레",
  "12724": "몽키핸즈 M3(중형) 5켤레",
  "12725": "몽키핸즈 M3(대형) 5켤레",
  "12726": "몽키핸즈 M3(대형) 10켤레",
  "12727": "이너홈 제스트 주방가위 SAVA2025(아이보리)",
  "12728": "이너홈 과도",
  "12729": "이너홈 셰프식도",
  "12730": "이너홈 야채식도",
  "12731": "썬터치 가스렌지 ST-SB4C(직사각 바람막이 대형)",
  "12732": "이너홈 튼튼 니트릴 고무장갑 소형 그린 면코팅 10P",
  "12733": "이너홈 튼튼 니트릴 고무장갑 중형 그린 면코팅 10P",
  "12734": "이너홈 튼튼 니트릴 고무장갑 대형 그린 면코팅 10P",
  "12735": "이너홈 튼튼 니트릴 고무장갑 특대형 그린 면코팅 10P",
  "12736": "몽키핸즈 M3(대형) 1켤레",
  "12737": "이너홈 알카라인 건전지 AA 20입",
  "12738": "이너홈 알카라인 건전지 AAA 20입",
  "12739": "이너홈 알카라인 건전지 AA 40입",
  "12740": "이너홈 알카라인 건전지 AAA 40입",
  "12741": "42g 표백 도트 목장갑 50개",
  "12742": "몽키핸즈 M3(중형) 1켤레",
  "12743": "이너홈 주방용세제 구연산5Kg",
  "12744": "이너홈 니트릴장갑 화이트 300매 소형",
  "12745": "이너홈 니트릴장갑 화이트 300매 중형",
  "12746": "이너홈 니트릴장갑 화이트 300매 대형",
  "12747": "이너홈 니트릴장갑 블랙 300매 소형",
  "12748": "이너홈 니트릴장갑 블랙 300매 중형",
  "12749": "이너홈 니트릴장갑 블랙 300매 대형",
  "12750": "수입_면장갑 55G_50켤레",
  "12751": "수입_목장갑 55g_50켤레",
  "12752": "썬터치 가스렌지 TANK W",
  "12753": "몽키핸즈 니트릴장갑 200매 화이트 소형",
  "12754": "몽키핸즈 니트릴장갑 200매 화이트 중형",
  "12755": "몽키핸즈 니트릴장갑 200매 화이트 대형",
  "12756": "몽키핸즈 니트릴장갑 200매 블랙 소형",
  "12757": "몽키핸즈 니트릴장갑 200매 블랙 중형",
  "12758": "몽키핸즈 니트릴장갑 200매 블랙 대형",
  "12759": "몽키핸즈 M1 소형 1켤레",
  "12760": "몽키핸즈 M1 중형 1켤레",
  "12761": "몽키핸즈 M1 대형 1켤레",
  "12762": "이너홈 주방용세제 베이킹소다 12Kg",
  "12763": "이너홈 주방용세제 베이킹소다 4Kg",
  "12764": "이너홈 주방용세제 과탄산소다 5Kg",
  "12765": "이너홈 더블 지퍼백 대형50매 4개",
  "12766": "RISCO ROLLBAG X-LARGE 40cmX50cm 400PCS",
  "12767": "RISCO ROLLBAG XX-LARGE 45cmX60cm 300PCS",
  "12768": "RISCO ROLLBAG XXX-LARGE 50cmX70cm 200PCS",
  "12769": "3번들 이너홈 롤백 (17X25,25X35,30X40) 600PCS",
  "12770": "4 BUNDLE RISCO ROLLBAG (17X25,25X35,30X40,35X45) 800PCS",
  "12771": "닥터바디 경추 베개",
  "12901": "이너홈 더블 지퍼백 대형50매",
  "12902": "이너홈 더블 지퍼백 중형50매",
  "12903": "이너홈 더블 지퍼백 소형50매",
  "12905": "조이엘로 가스렌지 G6",
  "12917": "이너홈 제스트 주방가위 SAVA2025 (그레이)",
  "12942": "이너홈 롤백 미니(17x25) 500매",
  "12943": "이너홈 롤백 소형(25X35) 500매",
  "12944": "이너홈 롤백 중형(30x40) 500매",
  "12945": "이너홈 롤백 대형(35X45) 500매",
  "12946": "이너홈 롤백 특대형(40X50) 400매",
  "12947": "이너홈 롤백 왕특대형(45X60) 300매",
  "12948": "이너홈 롤백 초특대형(50X70) 200매",
  "13048": "더롱 튼튼 니트릴 고무장갑 S(소형)",
  "13049": "더롱 튼튼 니트릴 고무장갑 M(중형)",
  "13050": "더롱 튼튼 니트릴 고무장갑 L(대형)",
  "13051": "버디버니 삭스타킹 화이트",
  "13054": "이너홈 튼튼 니트릴 고무장갑 그린 면코팅 3p 대형",
  "13056": "이너홈 튼튼 니트릴 고무장갑 그린 면코팅 3p 소형",
  "13058": "이너홈 튼튼 니트릴 고무장갑 그린 면코팅 3p 중형",
  "13062": "스노우스노우(퍼플)",
  "13063": "스노우스노우(오렌지)",
  "13064": "안보이는 양말(남성용/블랙)",
  "13065": "안보이는 양말(남성용/화이트)",
  "13066": "안보이는 양말(여성용/블랙)",
  "13067": "안보이는 양말(여성용/화이트)",
  "13068": "이너홈 과도 2개",
  "13069": "브랜디노 배송",
  "13079": "몽키핸즈 SMART 터치장갑 M2 소형 1켤레",
  "13080": "몽키핸즈 SMART 터치장갑 M2 중형 1켤레",
  "13084": "IH 세라믹 냄비 2종세트",
  "13087": "버디버니 삭스타킹 블랙",
  "13112": "이너홈 튼튼 니트릴 고무장갑 특대형 화이트 5P+집게고리",
  "13152": "케라틴 헤어 오일 세럼",
  "13153": "프리즈 컨트롤 리페어 헤어 마스크",
  "13154": "오라리쉬 탈모 증상 완화 샴푸 740ml",
  "13163": "이너홈x왕가의 후예 칫솔 미세모 38mm 골드_2개입",
  "13164": "이너홈x왕가의 후예 칫솔 미세모 38mm 실버_2개입",
  "13165": "버디버니 삭스타킹 블랙 화이트뒷줄",
  "13171": "벡셀 플래티넘 AAA 20P",
  "13307": "이너홈 셰프식도-사본1",
  "13407": "조이엘로 통주물 IH 프라이팬 28cm-사본1",
  "13444": "이너홈 튼튼 니트릴 고무장갑 특대형 화이트 3P+집게고리",
  "13471": "몽키핸즈 니트릴장갑 200매 화이트 중형-쿠팡",
  "13580": "이너홈 스마트폰 TOUCH 코팅장갑 10켤레 대형",
  "13596": "이너홈 니트릴장갑 화이트 200매 미니",
  "13599": "이너홈 위생접시 14cm 15입",
  "13600": "이너홈 위생접시 18cm 15입",
  "13601": "이너홈 위생접시 23cm 15입",
  "13602": "클라우드 휩 안티 헤어 로스 샴푸 740ml",
  "13631": "이너홈 튼튼 니트릴 고무장갑 소형 화이트 3P",
  "13632": "이너홈 튼튼 니트릴 고무장갑 중형 화이트 3P",
  "13633": "이너홈 튼튼 니트릴 고무장갑 대형 화이트 3P",
  "13634": "이너홈 튼튼 니트릴 고무장갑 소형 화이트 5P",
  "13635": "이너홈 튼튼 니트릴 고무장갑 중형 화이트 5P",
  "13636": "이너홈 튼튼 니트릴 고무장갑 대형 화이트 5P",
  "13637": "이너홈 튼튼 니트릴 고무장갑 특대형 그린 면코팅 3P",
  "13638": "이너홈 니트릴장갑 화이트 100매 특대",
  "13639": "이너홈 니트릴장갑 100매 블루 소형",
  "13640": "이너홈 니트릴장갑 100매 블루 중형",
  "13641": "이너홈 니트릴장갑 100매 블루 대형",
  "13642": "이너홈 니트릴장갑 블루 100매 특대",
  "13643": "이너홈 니트릴장갑 블랙 100매 특대",
  "13644": "클라우드 휩 안티 헤어 로스 샴푸 740ml X 2개",
  "13645": "케라틴 헤어 오일 세럼 45ml x 2개",
  "13646": "오라리쉬 헤어 프리즈 컨트롤 시스템 3단계 케어 3종세트 세럼, 샴푸, 헤어팩, 각 1개",
  "13647": "이너홈 니트릴장갑 200매 화이트 초소형",
  "13648": "고무장갑 특대형 2개 + 튼튼고무장갑 면코팅 특대형 2개",
  "13649": "발각질제거기(바이올렛)1개+샤워장갑2입",
  "13650": "이너홈 튼튼 니트릴 고무장갑 소형 바이올렛",
  "13651": "이너홈 튼튼 니트릴 고무장갑 중형 바이올렛",
  "13652": "이너홈 튼튼 니트릴 고무장갑 대형 바이올렛",
  "13653": "이너홈 튼튼 니트릴 고무장갑 소형 바이올렛 3P",
  "13654": "이너홈 튼튼 니트릴 고무장갑 중형 바이올렛 3P",
  "13655": "이너홈 튼튼 니트릴 고무장갑 대형 바이올렛 3P",
  "S12919": "이너홈 가위(아이보리)+가위(그레이)",
  "S12921": "이너홈 튼튼 니트릴 고무장갑 소형 화이트 3P+집게고리",
  "S12923": "이너홈 튼튼 니트릴 고무장갑 중형 화이트 3P+집게고리",
  "S12925": "이너홈 튼튼 니트릴 고무장갑 대형 화이트 3P+집게고리",
  "S12927": "이너홈 튼튼 니트릴 고무장갑 소형 화이트 5P+집게고리",
  "S12929": "이너홈 튼튼 니트릴 고무장갑 중형 화이트 5P+집게고리",
  "S12931": "이너홈 튼튼 니트릴 고무장갑 대형 화이트 5P+집게고리",
  "S12933": "이너홈 일회용 수세미 그레이 60매+베이지 60매",
  "S12935": "이너홈 튼튼 니트릴 고무장갑 소형 + 중형 화이트",
  "S12937": "이너홈 튼튼 니트릴 고무장갑 소형 + 대형 화이트",
  "S12939": "이너홈 튼튼 니트릴 고무장갑 중형 + 대형 화이트",
  "S12941": "더블 지퍼백 소형50매+중형50매+대형50매",
  "S12950": "이너홈 베이킹소다 2Kg+과탄산소다 1Kg+구연산 1Kg",
  "S12952": "이너홈 베이킹소다 2Kg X 3개+과탄산소다 1Kg",
  "S12954": "이너홈 니트릴장갑 200매 블랙 중형 + 100매 블랙 중형",
  "S12956": "이너홈 니트릴장갑 200매 블랙 소형 + 100매 블랙 소형",
  "S12958": "이너홈 니트릴장갑 200매 블랙 대형 + 100매 블랙 대형",
  "S12960": "이너홈 니트릴장갑 200매 화이트 소형 + 100매 화이트 소형",
  "S12962": "이너홈 니트릴장갑 200매 화이트 중형 + 100매 화이트 중형",
  "S12964": "이너홈 니트릴장갑 200매 화이트 대형 + 100매 화이트 대형",
  "S12966": "더블 지퍼백 소형50매+소형50매+중형50매",
  "S12968": "더블 지퍼백 소형50매+소형50매+대형50매",
  "S12970": "더블 지퍼백 중형50매+중형50매+소형50매",
  "S12972": "더블 지퍼백 중형50매+중형50매+대형50매",
  "S12974": "더블 지퍼백 대형50매+대형50매+중형50매",
  "S12976": "더블 지퍼백 대형50매+대형50매+소형50매",
  "S12978": "더블 지퍼백 소형100매+중형100매+대형100매",
  "S12980": "조이엘로 통주불 IH 올리브(그린) 궁중팬 28cm + 프라이팬 28cm",
  "S12982": "이너홈 과도 + 셰프식도 + 야채식도",
  "S12984": "이너홈 과도 + 야채식도 + 가위(아이보리)",
  "S12986": "이너홈 야채식도+이너홈 과도",
  "S12988": "조이엘로 통주물 IH 프라이팬 24cm + 프라이팬 28cm",
  "S12990": "조이엘로 통주물 IH 프라이팬 24cm + 프라이팬 30cm",
  "S12992": "조이엘로 통주물 IH 프라이팬 28cm + 프라이팬 30cm",
  "S12994": "조이엘로 통주물 IH 프라이팬 24cm + 궁중팬 24cm",
  "S12996": "조이엘로 통주물 IH 프라이팬 24cm + 궁중팬 28cm",
  "S12998": "조이엘로 통주물 IH 프라이팬 28cm + 궁중팬 24cm",
  "S13000": "조이엘로 통주물 IH 프라이팬 28cm + 궁중팬 28cm",
  "S13002": "조이엘로 통주물 IH 프라이팬 30cm + 궁중팬 24cm",
  "S13004": "조이엘로 통주물 IH 프라이팬 30cm + 궁중팬 28cm",
  "S13006": "조이엘로 통주물 IH 궁중팬 24cm + 궁중팬 28cm",
  "S13008": "이너홈 셰프식도 + 야채식도",
  "S13010": "이너홈 제스트 주방가위 (아이보리)+(그레이)",
  "S13012": "이너홈 과도 + 셰프식도 + 야채식도 + 주방가위(아이보리)",
  "S13014": "이너홈 셰프식도 + 아이보리 가위",
  "S13016": "이너홈 과도 + 셰프식도 + 가위(아이보리)",
  "S13018": "이너홈 야채식도 + 가위(아이보리)",
  "S13020": "이너홈 과도 + 가위(아이보리)",
  "S13022": "이너홈 셰프식도+이너홈 과도",
  "S13024": "이너홈 베이킹소다 2Kg+과탄산소다 1Kg+구연산 1Kg+일회용수세미 그레이 60매",
  "S13026": "이너홈 셰프식도 + 야채식도 + 아이보리 가위",
  "S13028": "이너홈 알카라인 건전지 AA 20입 + AAA 40입",
  "S13030": "이너홈 알카라인 건전지 AA 20입 + AAA 20입",
  "S13032": "이너홈 튼튼 니트릴 고무장갑 대형 + 수세미 그레이 60매",
  "S13034": "더블 지퍼백 소형50매+중형50매",
  "S13036": "더블 지퍼백 중형50매+대형50매",
  "S13038": "더블 지퍼백 소형50매+대형50매",
  "S13040": "튼튼고무장갑 특대형 화이트 + 행주 40매",
  "S13042": "이너홈 튼튼 니트릴고무장갑 중형 화이트 + 수세미 그레이 60매",
  "S13044": "이너홈 튼튼 니트릴고무장갑 소형 화이트 + 수세미 그레이 60매",
  "S13046": "이너홈 튼튼 니트릴고무장갑 특대형 화이트 + 수세미 그레이 60매",
  "S13090": "이너홈 올케어 집들이 6종 선물 세트",
};

export default ACODE_MAP;
